<template>
  <el-aside class="sidebar" width="200px">
    <div class="sidebar-header">
      <span class="sidebar-title">功能导航</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      background-color="#ffffff"
      text-color="#333333"
      active-text-color="#ffffff"
      :router="true"
    >
      <el-menu-item :class="item.isLine ? 'bottom-line' : ''"
        v-for="item in menuList"
        :key="item.path"
        :index="item.path"
      >
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
      curWebsite: this.$api.getWebsiteType(),
      menuList: [
        { path: '/panorama', title: '首页', icon: 'el-icon-data-line', pathD: ['/panorama'] },
        { path: '/dashboard', title: '政府审批项目', icon: 'el-icon-s-order', pathD: ['/dashboard'] },
        { path: '/agencyService', title: '产业链上游项目', icon: 'el-icon-connection', pathD: ['/agencyService'] },
        { path: '/projectManagement', title: '项目管理', icon: 'el-icon-collection', pathD: ['/projectManagement'], isLine: true },

        { path: '/landStatistics', title: '拿地项目统计', icon: 'el-icon-tickets', pathD: ['/landStatistics'] },
        { path: '/investSearch', title: '投资项目库', icon: 'el-icon-data-analysis', pathD: ['/investSearch'] },
        { path: '/contact', title: '联系人', icon: 'el-icon-user', pathD: ['/contact'] },
        { path: '/constructionProject', title: '建设行业库', icon: 'el-icon-coin', pathD: ['/constructionProject'] },
        { path: '/constructionIndustry', title: '建筑业数据', icon: 'el-icon-location-outline', pathD: ['/constructionIndustry'], isLine: true },

        // { path: '/monitoring', title: '建筑业数据', icon: 'el-icon-location' },
        // { path: '/statistics', title: '统计分析', icon: 'el-icon-data-analysis' },
        { path: '/totalEnterprises', title: '企业数据库', icon: 'el-icon-office-building', pathD: ['/totalEnterprises', '/enterpriseList'] },
        { path: '/chain', title: '产业图谱库', icon: 'el-icon-paperclip', pathD: ['/chain'] },
        { path: '/report', title: '研究报告库', icon: 'el-icon-document', pathD: ['/report'] },
        // { path: '/calculator', title: '关系计算器', icon: 'el-icon-s-grid', pathD: ['/calculator'] }
      ]
    }
  },
  computed: {
    activeMenu() {
      // 对比路由和 pathD，如果路由包含 pathD 中的路径，default-active 就是当前菜单的 path
      const menuItem = this.menuList.find(item => item.pathD && item.pathD.includes(this.$route.path));
      return menuItem ? menuItem.path : undefined;
    },
  },
  mounted() {
    if (this.curWebsite.type == 1) { // 22冶
      this.menuList = this.menuList.filter(item => item.path !== '/landStatistics' && item.path !== '/investSearch' 
      && item.path !== '/projectManagement' && item.path !== '/panorama');
    }
    if (this.curWebsite.type == 2) { // 协会
      this.menuList = this.menuList.filter(item => item.path !== '/contact' );
    }
    // 3 vip版功能最全
    if (this.curWebsite.type == 4) { // 深圳专属版(目前Sam说除了联系人其他都可以放)
      this.menuList = this.menuList.filter(item => item.path !== '/contact');
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
  z-index: 999;
}

.sidebar-header {
  padding: 20px 16px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-title {
  font-size: 14px;
  color: #1e3a5f;
  font-weight: 500;
  position: relative;
  padding-left: 10px;
}

.sidebar-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background-color: #1e3a5f;
  border-radius: 2px;
}

.sidebar-menu {
  border-right: none;
  padding-bottom: 12px;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 4px 8px;
  border-radius: 8px;
}

.sidebar-menu .el-menu-item.is-active {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%) !important;
  color: #fff !important;
}

.sidebar-menu .el-menu-item:hover:not(.is-active) {
  background-color: #f5f7fa;
}

.sidebar-menu .el-menu-item i {
  margin-right: 8px;
  font-size: 18px;
}

/* ========== 模块分割线（留白式通栏细线） ==========
   1. 去掉原来的灰色 border-bottom
   2. 用 ::after 画一条通栏极浅细线，上下留白形成"呼吸缝"
   3. 线色贴近背景，是分区提示而不是把菜单切碎 */
.sidebar-menu .el-menu-item.bottom-line {
  position: relative;
  margin-bottom: 22px;          /* 线下留白：分区间距的主要来源 */
}

.sidebar-menu .el-menu-item.bottom-line::after {
  content: '';
  position: absolute;
  left: -8px;                   /* 抵消菜单项 margin，通栏到侧边栏边缘 */
  right: -8px;
  bottom: -11px;                /* 线的位置：留白下沿 */
  height: 1px;
  background: rgb(211, 211, 211);          /* 极浅灰，接近背景色 */
}

/* 鼠标悬停时线保持在文字下方，不影响 hover 底色 */
.sidebar-menu .el-menu-item.bottom-line:hover:not(.is-active)::after {
  background: #e8ebef;
}
</style>